import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/research/src/components/layout.js";
import Image from '../../components/image';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Overview`}</h2>
    <p>{`Below are real-world examples of file inputs (outside of libraries).`}</p>
    <h3>{`GitHub - Attaching binaries to a release`}</h3>
    <p>{`The below demonstrates GitHub's UI for attaching binaries to a release.`}</p>
    <h4>{`Default`}</h4>
    <Image src="github-file-default.png" alt="GitHub - attaching release binaries - default state" mdxType="Image" />
    <br />
    <br />
    <h4>{`Focus`}</h4>
    <Image src="github-file-focus.png" alt="GitHub - attaching release binaries - focus state" mdxType="Image" />
    <br />
    <br />
    <h4>{`With selection`}</h4>
    <p>{`Supports multiple selections, in which case the selections stack at the top.`}</p>
    <Image src="github-file-selection.png" alt="GitHub - attaching release binaries - selection state" mdxType="Image" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      